import './App.css';
import MainContainer from './container/MainContainer';

function App() {
  
  
  return (
    <div className="App">
      <MainContainer />
    </div>
  );

};

export default App;
